import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExportDialogComponent } from './export-dialog/export-dialog.component';
import { JsonForKeyPipe } from './json-for-key.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [ExportDialogComponent, JsonForKeyPipe],
  imports: [
    CommonModule,
    FormsModule,
    DragDropModule,
    MatDialogModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule
  ],
  exports: [ExportDialogComponent]
})
export class ExportModule { }
